$(function() {
    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    $(':input[type="submit"]').prop('disabled', true);

    if ($("#agreeTerms").is(':checked')) {
      $(':input[type="submit"]').prop('disabled', false);
    }

    $.getJSON('/cart.js', function(cart) {
      
      if (cart.items.length) {
        $.each(cart.items, function(idx, obj){
          if (obj.product_title == '不織袋') {
            $('#addOption').prop('checked', true);
          }
        });
        $('.product-toption').css('opacity', '1');
      } else {
        $('.product-toption').css('opacity', '1');
      }
    });

    $( ".option-des-open" ).click(function() {
      $(".option-des").css("display", "block");
    });

    $( ".option-des-close" ).click(function() {
      $(".option-des").css("display", "none");
    });

    $('#addOption').click(function(){
      if($(this).prop("checked") == true){
        $.getJSON('/cart.js', function(cart) {
          let indexOption = cart.items.findIndex(item => item.id == '42885752684783');
          if (indexOption != -1) {
            $('#CartCount span:first-child').html(cart.item_count);
            var cartSubTotal = cart.total_price/100;
            $('.cart__footer .cart-subtotal .cart-subtotal__price').html('¥' + formatNumber(cartSubTotal) + '(税込)');
          } else {
            let dataProduct = [ {
              quantity: 1,
              id: '42885752684783'
            } ];

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                items: dataProduct
              },
              dataType: 'json',
              beforeSend: function() {
              },
              success: function (data) {
                $.getJSON('/cart.js', function(cart) {
                  $('#CartCount span:first-child').html(cart.item_count);
                  var cartSubTotal = cart.total_price/100;
                  $('.cart__footer .cart-subtotal .cart-subtotal__price').html('¥' + formatNumber(cartSubTotal) + ' (税込)');
                });
              },
              error: function(xhr, status, error) {
                var errors = xhr.responseJSON;
              }
            });
          }
        });
      }
      else if($(this).prop("checked") == false){
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: '42885752684783'
          },
          dataType: 'json',
          success: function (data) {
            $.getJSON('/cart.js', function(cart) {
              $('#CartCount span:first-child').html(cart.item_count);
              var cartSubTotal = cart.total_price/100;
              $('.cart__footer .cart-subtotal .cart-subtotal__price').html('¥' + formatNumber(cartSubTotal) + ' (税込)');

              if (cart.item_count === 0) {
                window.location.reload();
              }
            });
          },
          error: function(xhr, status, error) {
            var errors = xhr.responseJSON;
          }
        });
      }
    });

    $("#agreeTerms").on('change', function() {
      if (this.checked) {
        $(':input[type="submit"]').prop('disabled', false);
      } else {
        $(':input[type="submit"]').prop('disabled', true);
      }
    })
});
